import { put, takeLatest, call, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import refreshServicesAPI from '../../api/app';
import { Types, Creators as AppCreators } from '../../reducers/app';
import getState from '../../utils/getState';

function* requestRefreshServices(service, siteId) {
  if (service !== 'feather') {
    return yield call(refreshServicesAPI.cleanStoreCache, service, siteId);
  }

  return yield call(refreshServicesAPI.updateFeather, siteId);
}

function* resfreshServices({ service }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const result = yield call(requestRefreshServices, service, siteId);

    if (!result || !isEmpty(result.errors)) {
      throw result.errors.join('');
    }

    yield put(AppCreators.refreshServicesSuccess({ refreshResult: result.message, [`${service}IsLoading`]: false }));
  } catch (error) {
    yield put(AppCreators.refreshServicesError({ error, [`${service}IsLoading`]: false }));
  }
}

export default function* watch() {
  yield takeLatest(Types.REFRESH_SERVICES_REQUEST, resfreshServices);
}
